const interceptorsResponseState = {
    gatewayTimeout: false,
    interceptorsInitialized: false,
    unauthorized: false
};
export default interceptorsResponseState;
